
    import './styles.scoped.css';
    export default {
  "radio-control": "awsui_radio-control_1v1hk_bzdk2_33",
  "outline": "awsui_outline_1v1hk_bzdk2_47",
  "styled-circle-border": "awsui_styled-circle-border_1v1hk_bzdk2_69",
  "styled-circle-disabled": "awsui_styled-circle-disabled_1v1hk_bzdk2_73",
  "styled-circle-readonly": "awsui_styled-circle-readonly_1v1hk_bzdk2_73",
  "styled-circle-fill": "awsui_styled-circle-fill_1v1hk_bzdk2_78",
  "styled-circle-checked": "awsui_styled-circle-checked_1v1hk_bzdk2_94",
  "awsui-radio-select": "awsui_awsui-radio-select_1v1hk_bzdk2_1"
};
  